const features = [
  {
    icon: 'ri-flashlight-line',
    title: '24小时不打烊',
    desc: '编辑团队全天候追踪全网热点，网红塌房黑料与网曝门事件第一时间更新发布，让你永远走在吃瓜前线。',
    color: 'bg-primary-100 text-primary-600',
  },
  {
    icon: 'ri-global-line',
    title: '全网内容聚合',
    desc: '覆盖微博、抖音、小红书等全平台热门内容，51吃瓜黑料一站式整合明星爆料与博主反差记录，无需切换多个APP。',
    color: 'bg-accent-100 text-accent-700',
  },
  {
    icon: 'ri-smartphone-line',
    title: '移动端畅快浏览',
    desc: '51吃瓜黑料网址入口全面适配手机端，无论iOS还是安卓，打开浏览器就能在线观看最新吃瓜内容与视频。',
    color: 'bg-secondary-100 text-secondary-700',
  },
  {
    icon: 'ri-shield-check-line',
    title: '内容来源明确',
    desc: '每一条爆料均标注信息来源，坚持「不做谣言制造者」原则。吃瓜资源丰富但有理有据，让你放心吃瓜。',
    color: 'bg-primary-100 text-primary-600',
  },
  {
    icon: 'ri-user-heart-line',
    title: '百万瓜友社区',
    desc: '活跃的读者评论区与海量互动数据，吃瓜不再是一个人的狂欢。加入51吃瓜黑料，和百万瓜友一起在线追料。',
    color: 'bg-accent-100 text-accent-700',
  },
];

export default function Features() {
  return (
    <section id="features" className="w-full py-12 md:py-16 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-6 rounded-full bg-primary-500"></div>
          <h2 className="text-xl md:text-2xl font-heading text-foreground-900">
            平台特色
          </h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {features.map((f) => (
            <div
              key={f.title}
              className="group p-6 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-300/50 hover:shadow-md transition-all duration-300 cursor-pointer text-center"
            >
              <div className={`w-12 h-12 rounded-xl ${f.color} flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform duration-200`}>
                <i className={`${f.icon} text-xl`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-800 mb-2 whitespace-nowrap">
                {f.title}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed">
                {f.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}